import { FC } from "react";
import { PageHeader } from "@hostingbv/lib/src/components/content/PageHeader";
import { ContentContainer } from "@hostingbv/lib/src/components/content/ContentContainer";
import { useParams } from "react-router-dom";
import { Breadcrumbs } from "@hostingbv/lib/src/components/content/Breadcrumbs";
import { Loading } from "@hostingbv/lib/src/components/Loading";
import { Server } from "@hostingbv/lib/src/api/partner/models/Server";
import { EntityNotesButton } from "../components/EntityNotesButton";
import { faServer } from "@fortawesome/free-solid-svg-icons";
import { PageIconHeader } from "../../../lib/src/components/PageIconHeader";
import { useServer } from "@hostingbv/lib/src/api/partner/PartnerHooks";
import { WindhostingServerDetails } from "../components/WindhostingServerDetails";
import { VirtualServerDetails } from "../components/VirtualServerDetails";
import { PleskServerDetails } from "../components/PleskServerDetails";
import { SectionHeader } from "@hostingbv/lib/src/components/content/SectionHeader";
import { DataTable } from "@ventumsoftware/react-toolkit";

export const ServerDetails: FC = () => {
  const { server: uuid } = useParams();
  const { data: server, isLoading } = useServer(uuid!);

  return (
    <ContentContainer>
      <PageIconHeader icon={faServer}>
        <Breadcrumbs
          currentPage={server?.displayName ?? "Server"}
          crumbs={[{ label: "Servers", href: "/servers" }]}
        />
        <PageHeader>
          {server === null ? (
            <span
              className={"block h-8 w-36 rounded-lg bg-slate-200 animate-pulse"}
            ></span>
          ) : (
            server.displayName
          )}
          {!server?.isShared ? <EntityNotesButton entity={server} /> : <></>}
        </PageHeader>
      </PageIconHeader>

      <Loading loading={isLoading}>
        {server && (
          <>
            {server.serverType === "shared_hosting" && (
              <PleskServerDetails server={server} />
            )}
            {server.serverType === "virtual_server" && (
              <VirtualServerDetails server={server} />
            )}
            {server.serverType === "windhosting_server" && (
              <WindhostingServerDetails server={server} />
            )}
            {!server.isShared && <ContractsOverview server={server!} />}
          </>
        )}
      </Loading>
    </ContentContainer>
  );
};

function ContractsOverview(props: { server: Server }) {
  return <>
    <SectionHeader>Contracts</SectionHeader>
    <div className={"mb-8"}>
      <DataTable
        keyProperty={'id'}
        data={props.server.contracts}
        columns={[
          { property: 'displayName', header: 'Description' },
          {
            property: 'renewalAt', header: 'Next invoice', transform: (v, c) => {
              if (c.cancelledAt !== null) {
                return <span className={'bg-red-600 text-white font-medium text-xs px-2 rounded-full'}>Cancelled</span>
              }
              return v.toLocaleDateString('nl');
            }
          },
          { property: 'billingPeriod', header: 'Invoice period', transform: (v) => `Every ${v} ${v > 1 ? 'months' : 'month'}` },
          { property: 'amount', header: 'Amount (Excl. VAT)', transform: (v) => `€ ${(v / 100).toFixed(2)}` },
        ]} />
    </div>
  </>
}
